import {BannerSocialFileData} from "../types/banners-social-modal.types";
import {defaultFileParams} from "../../../../../../../core/models/default-file-params";

export const defaultBannerSocialFileData: BannerSocialFileData = {
  id: 0,
  fileName: '',
  file: defaultFileParams,
  priority: 0,
  history: []
}
